import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DynamicFormComponent } from '../../_shared/components/dynamic-form/dynamic-form.component';

import { DeviceDetectorService } from 'ngx-device-detector';
import { FieldConfig } from '../../_models/field.interface';
import { Validators } from '@angular/forms';

export interface Mensagem {
  mensagem: string;
  remetente: Remetente;
}
export enum Remetente {
  usuario = 1,
  bot = 2,
}

import { MatSliderChange } from '@angular/material/slider';
import { ActivatedRoute, Router } from '@angular/router';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { Membro } from '../../_models/membro';
import Swal from 'sweetalert2';
import { AuthService } from '../../_services/auth.service';
import { ValidacaoService } from '../../_services/validacao.service';

@Component({
  selector: 'app-saibamais',
  templateUrl: './saibamais.component.html',
  styleUrls: ['./saibamais.component.scss'],
})
export class SaibaMaisComponent implements OnInit {
  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;
  @ViewChild('chatScroll') private chatScroll: ElementRef;

  regConfigBeneficiosCacauLover: FieldConfig[];

  regConfigCadastroLover: FieldConfig[];
  regConfigCadastroLoverCampos1: FieldConfig[];
  regConfigCadastroLoverCampos2: FieldConfig[];
  regConfigCadastroLoverCampos3: FieldConfig[];
  regConfigCadastroLoverCampos4: FieldConfig[];
  regConfigCadastroLoverCampos5: FieldConfig[];
  regConfigCadastroLoverCampos6: FieldConfig[];
  regConfigChatIcon: FieldConfig[];

  regConfigBeneficiosLabel: FieldConfig[];
  regConfigBeneficiosPrecos: FieldConfig[];
  regConfigBeneficiosPromocoes: FieldConfig[];
  regConfigBeneficiosExperiencias: FieldConfig[];
  regConfigBeneficiosCashback: FieldConfig[];
  regConfigBeneficiosOutros: FieldConfig[];

  regConfigCadastroLoverCamposRodape: FieldConfig[];
  regDescontosParaLovers: FieldConfig[];
  regConfigMilhoes: FieldConfig[];

  etapaAtual: number = 1;
  regConfigPopupTermos: FieldConfig[] = [];
  regConfigPopupRegulamento: FieldConfig[] = [];

  membro: Membro = new Membro();

  // Chat para cadastro do Cacau Lover
  cacauLoverCadastro: Membro = new Membro();

  regConfigCadastroCacauLover: FieldConfig[];
  regConfigCadastroCacauLoverFooter: FieldConfig[];
  regConfigCadastroCacauLoverTermos: FieldConfig[];
  regConfigCadastroCacauLoverFinalizar: FieldConfig[];

  chatMensagens: Mensagem[] = [];
  indexChat: number = 1;
  indexChatBot: number = 0;

  exibePopupChatLover: boolean = false;

  chatMensagensBot: Mensagem[] = [
    {
      mensagem: 'Vamos fazer agora o seu cadastro, é super rápido.',
      remetente: 2,
    },
    { mensagem: 'Qual é o seu CPF?', remetente: 2 },
    {
      mensagem:
        'Com essas informações podemos oferecer muitas coisas legais para você.',
      remetente: 2,
    },
    { mensagem: 'Qual é o seu nome completo?', remetente: 2 },
    { mensagem: 'Legal, {NOME}.', remetente: 2 },
    { mensagem: 'Agora preciso que informe o seu e-mail.', remetente: 2 },
    {
      mensagem: 'Legal, agora me fala qual o número do seu celular.',
      remetente: 2,
    },
    { mensagem: 'E sua data de nascimento?', remetente: 2 },
    {
      mensagem: 'Agora é necessário aceitar os termos e condições do programa',
      remetente: 2,
    },
    {
      mensagem:
        'Cadastro concluído! Você já pode aproveitar os descontos na loja!',
      remetente: 2,
    },
  ];
  chatMensagensBotErro: Mensagem[] = [
    { mensagem: 'O CPF informado não é válido.', remetente: 2 },
    { mensagem: 'Certifique se informou o nome corretamente.', remetente: 2 },
    {
      mensagem: 'O número informado não é válido, tente novamente.',
      remetente: 2,
    },
    {
      mensagem: 'A data de nascimento informada não é válida, tente novamente.',
      remetente: 2,
    },
    {
      mensagem: 'A senha não cumpre os requisitos, tente outra.',
      remetente: 2,
    },
    {
      mensagem: 'É necessário aceitar os termos para se tornar um Cacau Lover.',
      remetente: 2,
    },
    {
      mensagem: 'O nome deve conter apenas letras.',
      remetente: 2,
    },
    {
      mensagem:
        'A senha deve cumprir os requisitos sendo: tamanho minimo de 8 caracteres, letras maiúsculas e minúsculas, número e caractere especial.',
      remetente: 2,
    },
    {
      mensagem:
        'Infelizmente não foi possível realizar, tente novamente mais tarde.',
      remetente: 2,
    },
    {
      mensagem: 'O e-mail informado não é válido, tente novamente.',
      remetente: 2,
    },
    {
      mensagem: 'Digite alguma coisa antes de tentar enviar.',
      remetente: 2,
    },
    {
      mensagem: 'Já existe um cadastro com o CPF informado.',
      remetente: 2,
    },
    {
      mensagem:
        'Apenas pessoas maiores de 18 anos podem participar do programa!',
      remetente: 2,
    },
  ];

  // LOADERS - SKELETON
  public carregandoDescontos: boolean = false;
  public exibirLoaderFullscreen: boolean = false;

  constructor(
    private fidelidadeService: FidelidadeService,
    private router: Router,
    private AuthService: AuthService,
    private route: ActivatedRoute,
    private validacao: ValidacaoService
  ) {
    this.route.params.subscribe((params) => {
      var abrirChat = params['abrirChat'];

      if (abrirChat === 'chat') {
        this.carregarChatCadastro();
      }
    });

    fidelidadeService.obterConfiguracaoPorDescricao('termos').subscribe(
      (sucesso) => {
        this.processarSucessoTermos(sucesso);
      },
      (falha) => {
        this.processarFalhaTermos(falha);
      }
    );

    fidelidadeService.obterConfiguracaoPorDescricao('regulamento').subscribe(
      (sucesso) => {
        this.processarSucessoRegulamento(sucesso);
      },
      (falha) => {
        this.processarFalhaRegulamento(falha);
      }
    );
  }

  ngOnInit(): void {
    this.carregandoDescontos = true;
    this.fidelidadeService.obterDescontoParaLovers(2).subscribe(
      (sucesso) => {
        this.processarSucessoConteudoCarrossel(sucesso);
      },
      (falha) => {
        this.processarFalhaConteudoCarrossel(falha);
      }
    );

    var self = this;

    this.regConfigChatIcon = [
      {
        type: 'image',
        src: 'assets/images/others/selo_chat_cacaulovers.png',
        style(): object {
          return;
        },
        onClick(): void {
          self.carregarChatCadastro();
        },
      },
    ];

    this.regConfigBeneficiosLabel = [
      {
        type: 'label',
        label: `Olá,`,
        class: 'label__hello',
        style(): object {
          return {
            'font-weight': '700',
            color: '#E5AE96',
          };
        },
        onClick(): void {},
      },
      {
        type: 'label',
        label: `Que bom saber que você também é apaixonada por chocolate.\nCacau Lovers é o programa de benefícios da Cacau Show. Nele você vai ter acesso a:`,
        class: 'label__explicativo',
        style(): object {
          return {
            color: '#ffffff',
          };
        },
        onClick(): void {},
      },
    ];

    var iconeWidth: object = {
      width: '30px',
    };
    var labelStyle: object = {
      width: '100%',
      color: '#fff',
      // 'font-size': '0.8em',
      'margin-top': '10px',
      'font-weight': '100',
      'margin-left': '5px',
    };
    this.regConfigBeneficiosPrecos = [
      {
        type: 'image',
        src: 'assets/images/icons/precos.png',
        style(): object {
          return iconeWidth;
        },
        onClick(): void {},
      },
      {
        type: 'label',
        label: `Preços Exclusivos`,
        class: 'label__beneficios',
        style(): object {
          return labelStyle;
        },
        onClick(): void {},
      },
    ];
    this.regConfigBeneficiosPromocoes = [
      {
        type: 'image',
        src: 'assets/images/icons/desconto.png',
        style(): object {
          return iconeWidth;
        },
        onClick(): void {},
      },
      {
        type: 'label',
        label: `Promoções imperdíveis`,
        class: 'label__beneficios',
        style(): object {
          return labelStyle;
        },
        onClick(): void {},
      },
    ];
    this.regConfigBeneficiosExperiencias = [
      {
        type: 'image',
        src: 'assets/images/icons/experiencias.png',
        style(): object {
          return iconeWidth;
        },
        onClick(): void {},
      },
      {
        type: 'label',
        label: `Experiêncas incríveis`,
        class: 'label__beneficios',
        style(): object {
          return labelStyle;
        },
        onClick(): void {},
      },
    ];
    //this.regConfigBeneficiosCashback = [
    //{
    //type: 'image',
    //src: 'assets/images/icons/cashback.png',
    //style(): object {
    //return iconeWidth;
    //},
    //onClick(): void { },
    //},
    //{
    //type: 'label',
    //label: `Cashback em suas compras.`,
    //class: 'label__beneficios',
    //style(): object {
    //return labelStyle;
    //},
    //onClick(): void { },
    //},
    //];
    this.regConfigBeneficiosOutros = [
      {
        type: 'label',
        label: `E muito mais! Falta pouco para você aproveitar todas as vantagens de ser um Cacau Lover, faça seu cadastro.`,
        class: 'label__beneficios',
        style(): object {
          return labelStyle;
        },
        onClick(): void {},
      },
    ];

    // this.regConfigBeneficiosCacauLover = [
    //     {
    //         type: 'label',
    //         label: `Olá,`,
    //         style(): object {
    //             return {
    //                 'font-weight': '400',
    //                 'font-size': '24px',
    //                 color: '#512111',
    //                 'margin-top': '30px',
    //                 'margin-left': '30px',
    //             };
    //         },
    //         onClick(): void { },
    //     },
    //     {
    //         type: 'label',
    //         label: `Ficamos felizes em saber que você \n quer ser um Cacau Lover para ter:`,
    //         style(): object {
    //         return {
    //                 'font-weight': '400',
    //                 'font-size': '14px',
    //                 color: '#512111',
    //                 'margin-left': '30px',
    //             };
    //         },
    //         onClick(): void { },
    //     },
    //     {
    //         type: 'image',
    //         src: 'assets/images/cacau-lovers_icone-desconto.png',
    //         style(): object {
    //             return {
    //                 right: '245px',
    //                 position: 'absolute',
    //             };
    //         },
    //         onClick(): void { },
    //     },
    //     {
    //         type: 'label',
    //         label: `Acesso há promoções \n imperdíveis.`,
    //         style(): object {
    //             return {
    //                 'font-weight': '700',
    //                 'font-size': '14px',
    //                 color: '#512111',
    //                 'margin-top': '15px',
    //                 position: 'absolute',
    //                 right: '80px',
    //             };
    //         },
    //         onClick(): void { },
    //     },
    //     {
    //         type: 'image',
    //         src: 'assets/images/cacau-lovers_icone-experiencias.png',
    //         style(): object {
    //             return {
    //                 right: '40px',
    //                 position: 'absolute',
    //                 'margin-top': '65px',
    //             };
    //         },
    //         onClick(): void { },
    //     },
    //     {
    //         type: 'label',
    //         label: `Experiêncas incríveis \n e apaixonantes.`,
    //         style(): object {
    //             return {
    //                 'font-weight': '700',
    //                 'font-size': '14px',
    //                 color: '#512111',
    //                 'margin-top': '80px',
    //                 position: 'absolute',
    //                 right: '110px',
    //             };
    //         },
    //         onClick(): void { },
    //     },
    //     {
    //         type: 'image',
    //         src: 'assets/images/cacau-lovers_icone-cashback.png',
    //         style(): object {
    //             return {
    //                 'margin-top': '125px',
    //                 right: '245px',
    //                 position: 'absolute',
    //             };
    //         },
    //         onClick(): void { },
    //     },
    //     {
    //         type: 'label',
    //         label: `Cashback em todas \n as suas compras.`,
    //         style(): object {
    //             return {
    //                 'font-weight': '700',
    //                 'font-size': '14px',
    //                 color: '#512111',
    //                 position: 'absolute',
    //                 right: '95px',
    //                 'margin-top': '140px',
    //             };
    //         },
    //         onClick(): void { },
    //     },
    // ];

    this.regConfigCadastroLover = [
      {
        type: 'label',
        label: `VEM APROVEITAR TUDO ISSO, \n SEJA UM CACAU LOVER!`,
        style(): object {
          return {
            'font-weight': '400',
            'font-size': '14px',
            color: '#ffffff',
            'margin-bottom': '15px',
            'margin-top': '20px',
            'margin-left': '0px',
          };
        },
        onClick(): void {},
      },
    ];

    var input: object = {
      width: '100%',
      height: '33px',
      'background-color': '#FFFFFF',
      'margin-bottom': '-0.50em',
    };
    var label: object = {
      'font-family': 'Sagona',
      'font-style': 'normal',
      'font-weight': '400',
      'font-size': '15px',
      color: '#ffffff',
      height: '0px',
      'letter-spacing:': '-0.01em',
      'white-space': 'pre-line',
    };
    var checkboxCampo1: object = {
      'font-weight': '400',
      'font-size': '12px',
      'text-align': 'left',
      width: '310px',
      'line-height': '11px',
      'margin-top': '48px',
    };

    this.regConfigCadastroLoverCampos1 = [
      {
        type: 'label',
        label: `Qual o seu CPF?`,
        style(): object {
          return label;
        },
        onClick(): void {},
      },
      {
        type: 'input',
        inputType: 'text',
        inputmode: 'numeric',
        name: 'cpf',
        mask: '000.000.000-00',
        label: '___.___.___-__',
        value: '',
        styleDivPrincipal(): object {
          return {
            width: '300px',
          };
        },
        style(): object {
          return input;
        },
        onClick() {
          return;
        },
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatorio',
          },
          {
            name: 'pattern',
            validator: Validators.pattern('^\\d{11}$'),
            message: 'CPF Inválido',
          },
        ],
      },
      {
        type: 'checkbox',
        label: `Li e aceito os termos javascript:abrirFecharPopupTermos(this,true) e condições javascript:abrirFecharPopupRegulamento(this,true) do programa Cacau Lovers`,
        name: 'aceitaTermo',
        value: false,
        style(): object {
          return checkboxCampo1;
        },
      },
      // {
      //   type: 'checkbox',
      //   label:
      //     'Eu aceito receber mensagens \n promocionais e transacionais da Cacau Show por SMS, E-mail e WhatsApp.',
      //   name: 'aceitaReceberPromocoes',
      //   value: false,
      //   style(): object {
      //     return checkboxCampo1;
      //   },
      // },
    ];

    this.regConfigCadastroLoverCampos2 = [
      {
        type: 'label',
        label: `Qual o seu nome completo?`,
        style(): object {
          return label;
        },
        onClick(): void {},
      },
      {
        type: 'input',
        inputType: 'text',
        name: 'nome',
        maxSize: 100,
        label: 'Nome',
        value: '',
        styleDivPrincipal(): object {
          return { width: '270px' };
        },
        style(): object {
          return input;
        },
        onClick() {
          return;
        },
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatório',
          },
          {
            name: 'pattern',
            validator: Validators.pattern('^[a-zA-ZÀ-ú][a-zA-ZÀ-ú\\s]+$'),
            message: 'Nome deve conter apenas letras',
          },
        ],
      },
      {
        type: 'input',
        inputType: 'text',
        name: 'sobrenome',
        maxSize: 100,
        label: 'Sobrenome',
        value: '',
        styleDivPrincipal(): object {
          return { width: '270px' };
        },
        style(): object {
          return input;
        },
        onClick() {
          return;
        },
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatório',
          },
          {
            name: 'pattern',
            validator: Validators.pattern('^[a-zA-ZÀ-ú][a-zA-ZÀ-ú\\s]+$'),
            message: 'Sobrenome deve conter apenas letras',
          },
        ],
      },
    ];

    this.regConfigCadastroLoverCampos3 = [
      {
        type: 'label',
        label: `Quais as suas informações \n de contato?`,
        style(): object {
          return label;
        },
        onClick(): void {},
      },
      {
        type: 'input',
        inputType: 'email',
        name: 'email',
        maxSize: 300,
        label: 'E-mail',
        value: '',
        styleDivPrincipal(): object {
          return { width: '310px' };
        },
        style(): object {
          return input;
        },
        onClick() {
          return;
        },
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatório',
          },
          {
            name: 'pattern',
            validator: Validators.pattern(
              '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$'
            ),
            message: 'E-mail Inválido',
          },
        ],
      },
      {
        type: 'input',
        inputType: 'text',
        name: 'celular',
        inputmode: 'numeric',
        label: 'Celular',
        mask: '(00) 00000-0000',
        value: '',
        maxSize: 16,
        styleDivPrincipal(): object {
          return { width: '310px' };
        },
        style(): object {
          return input;
        },
        onClick() {
          return;
        },
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatório',
          },
          {
            name: 'pattern',
            validator: Validators.pattern('^(\\+\\d{1,3}[- ]?)?\\d{11}$'),
            message: 'Telefone Inválido',
          },
        ],
      },
    ];

    this.regConfigCadastroLoverCampos4 = [
      {
        type: 'label',
        label: `Qual é a sua data de nascimento?`,
        value: '1988-02-07',
        style(): object {
          return label;
        },
        onClick(): void {},
      },
      {
        type: 'input',
        inputType: 'text',
        mask: '00/00/0000',
        label: 'DD/MM/AAAA',
        name: 'dataNascimento',
        styleDivPrincipal(): object {
          return { width: '310px' };
        },
        style(): object {
          return input;
        },
        onClick() {
          return;
        },
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatorio',
          },
        ],
      },
    ];

    this.regConfigCadastroLoverCampos5 = [
      {
        type: 'label',
        label: `Escolha a sua senha.`,
        style(): object {
          return label;
        },
        onClick(): void {},
      },
      {
        type: 'image',
        src: 'assets/images/icons/olho_aberto.png',
        styleDivPrincipal(): object {
          return {
            position: 'relative',
            display: 'contents',
          };
        },
        style(): object {
          return {
            width: '30px',
            height: '30px',
            position: 'absolute',
            background: 'rgba(244, 178, 65, 0.5)',
            'border-radius': '500px',
            'margin-top': '14px',
            'margin-left': '105px',
            'z-index': '5',
          };
        },
        onClick: () => this.exibirSenha(),
      },
      {
        type: 'input',
        inputType: 'password',
        name: 'senha',
        label: '************',
        value: '',
        maxSize: 100,
        styleDivPrincipal(): object {
          return { width: '270px' };
        },
        style(): object {
          return { width: '85%' };
        },
        onClick() {},
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatorio',
          },
          {
            name: 'pattern',
            validator: Validators.pattern(
              '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\\d$@$!%*?&].{7,}$'
            ),
            message:
              'O campo deve cumprir os requisitos sendo: tamanho minimo de 8 caracteres, letras maiúsculas e minúsculas, número e caractere especial',
          },
        ],
      },
      {
        type: 'image',
        src: 'assets/images/icons/olho_aberto.png',
        styleDivPrincipal(): object {
          return {
            position: 'relative',
            display: 'contents',
          };
        },
        style(): object {
          return {
            width: '30px',
            height: '30px',
            position: 'absolute',
            background: 'rgba(244, 178, 65, 0.5)',
            'border-radius': '500px',
            'margin-top': '14px',
            'margin-left': '105px',
            'z-index': '5',
          };
        },
        onClick: () => this.exibirSenha(),
      },
      {
        type: 'input',
        inputType: 'password',
        name: 'confirmarSenha',
        maxSize: 100,
        label: '************',
        value: '',
        styleDivPrincipal(): object {
          return { width: '270px' };
        },
        style(): object {
          return { width: '85%' };
        },
        onClick() {},
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo obrigatorio',
          },
          // {
          //     name: 'pattern',
          //     validator: Validators.pattern(
          //         '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&].{7,}$'
          //     ),
          //     message:
          //         'O campo deve cumprir os requisitos sendo: tamanho minimo de 8 caracteres, letras maiúsculas e minúsculas, número e caractere especial',
          // },
        ],
      },
    ];

    this.regConfigCadastroLoverCampos6 = [
      {
        type: 'label',
        label: `PARABÉNS! \n SEU CADASTRO FOI CONCLUÍDO.`,
        style(): object {
          return label;
        },
        onClick(): void {},
      },
      {
        type: 'image',
        src: 'assets/images/others/selo_cacaulovers.png',
        style(): object {
          return {
            'margin-top': '15px',
            'z-index': '1',
          };
        },
        onClick(): void {},
      },
    ];

    this.regConfigCadastroLoverCamposRodape = [
      {
        type: 'slider',
        name: 'sliderCadastro',
        visible: true,
        value: 1,
        maxSize: 6,
        disabled: true,
        style(): object {
          return { width: '205px' };
        },
        change: (event: MatSliderChange) =>
          this.adequarTela(event.value, false),
      },
      {
        type: 'buttonImage',
        icon: ['assets/images/icons/voltar.png'],
        visible: false,
        style(): object {
          return {
            left: '10px',
            position: 'absolute',
          };
        },
        styleDivPrincipal(): object {
          return { cursor: 'pointer' };
        },
        onClick: () => this.voltarEtapa(),
      },
      {
        type: 'button',
        label: 'Continuar Cadastro',
        style(): object {
          return {
            width: '250px',
            display: 'block',
            margin: 'auto',
            'background-color': 'var(--button-background-secondary-color)',
            color: 'var(--button-text-secondary-color)',
          };
        },
        onClick: () => this.adequarTela(0, false),
      },
    ];

    // this.regDescontosParaLovers = [
    //     {
    //         type: 'carouselCard',
    //         detailLabel: 'Descontos\npara\nLovers',
    //         titleList: [
    //             'ChocoFriday',
    //         ],
    //         descriptionLabel: [
    //             'Já pensou em comprar 2 caixas\nMonteBello por apenas R$16,00?',
    //         ],
    //         buttonLabel: 'Saiba mais',
    //         isMultiple: true,
    //         singleLink: '/perfil',
    //         srcList: [
    //             'assets/images/contents/choco_friday.jpg',
    //         ],
    //     },
    // ];

    this.regConfigMilhoes = [
      {
        type: 'label',
        label: 'SOMOS MAIS DE 4 MILHÕES',
        style(): object {
          return {
            width: '100%',
            color: '#461F1A',
            'text-align': 'center',
            'font-weight': '600',
            'font-size': '14px',
            margin: '14px 0px',
          };
        },
        onClick: () => {},
      },
      {
        type: 'image',
        src: 'assets/images/rectangle29.jpg',
        style(): object {
          return {
            width: '90%',
            display: 'block',
            margin: 'auto',
            'margin-bottom': '20px',
          };
        },
        onClick: () => {},
      },
    ];
  }

  processarSucessoConteudoCarrossel(sucesso): void {
    var conteudoCarrossel = [];

    var carrossel = {
      type: 'carouselCard',
      detailLabel: 'Desconto para lovers',
      titleList: [],
      descriptionLabel: [],
      isMultiple: true,
      buttonLabels: [],
      link: [],
      srcList: [],
    };

    sucesso.forEach((conteudo) => {
      carrossel.titleList.push(conteudo.titulo);
      carrossel.descriptionLabel.push(conteudo.descricao);
      carrossel.buttonLabels.push(conteudo.NomeBotao);
      carrossel.link.push(conteudo.link);
      carrossel.srcList.push(conteudo.imagemBase64);
    });

    conteudoCarrossel.push(carrossel);

    this.regDescontosParaLovers = conteudoCarrossel;
    this.carregandoDescontos = false;
  }

  processarFalhaConteudoCarrossel(falha): void {
    console.error(
      'Ocorreu um erro ao tentar obter o conteúdo do carrossel',
      falha
    );
    this.carregandoDescontos = false;
  }

  exibirSenha(): void {
    if (this.regConfigCadastroLoverCampos5[2].inputType === 'password') {
      this.regConfigCadastroLoverCampos5[1].src =
        'assets/images/icons/olho_fechado.png';
      this.regConfigCadastroLoverCampos5[3].src =
        'assets/images/icons/olho_fechado.png';

      this.regConfigCadastroLoverCampos5[2].inputType = 'text';
      this.regConfigCadastroLoverCampos5[4].inputType = 'text';
    } else {
      this.regConfigCadastroLoverCampos5[1].src =
        'assets/images/icons/olho_aberto.png';
      this.regConfigCadastroLoverCampos5[3].src =
        'assets/images/icons/olho_aberto.png';

      this.regConfigCadastroLoverCampos5[2].inputType = 'password';
      this.regConfigCadastroLoverCampos5[4].inputType = 'password';
    }
  }

  voltarEtapa() {
    this.etapaAtual -= 1;
    this.regConfigCadastroLoverCamposRodape[0].value = this.etapaAtual;
    this.regConfigCadastroLoverCamposRodape[1].visible = this.etapaAtual != 1;

    this.regConfigCadastroLoverCamposRodape[2].label = 'Continuar Cadastro';
  }

  adequarTela(step: number, subtrair: boolean) {
    //ValidaFormulário
    var formularioFalhaRegraNegocio: Boolean = false;
    var formularioValido: Boolean = this.formularioValido(this.etapaAtual);
    if (formularioValido || subtrair == true) {
      //Armazena as informações
      if (this.etapaAtual == 1) {
        this.membro.cpf = this.regConfigCadastroLoverCampos1[1].value;
        this.membro.aceiteTermo = this.regConfigCadastroLoverCampos1[2].value;
        this.membro.enviaComunicacao = true;

        if (!this.validacao.validarCPF(this.membro.cpf)) {
          Swal.fire({
            title: 'O CPF informado não é válido!.',
            text: 'Preencha o campo corretamente para prosseguir com o cadastro',
            icon: 'warning',
            timer: 3000,
            showConfirmButton: false,
            timerProgressBar: true,
          });
          return;
        }

        if (!this.membro.aceiteTermo) {
          formularioFalhaRegraNegocio = true;
        }

        this.fidelidadeService
          .verificarSeJaEstaCadastrado(this.membro.cpf)
          .subscribe(
            (res) => {
              if (res.message === 'CacauLover - Cliente cadastrado na base!') {
                Swal.fire({
                  text: 'Você já é um Cacau Lover, logue-se para aproveitar os benefícios.',
                  icon: 'info',
                  timer: 3000,
                  showConfirmButton: false,
                  timerProgressBar: true,
                });

                this.etapaAtual = 6;

                this.regConfigCadastroLoverCamposRodape[2].label =
                  'Faça o login e aproveite';
                this.regConfigCadastroLoverCamposRodape[0].visible = false;
                this.regConfigCadastroLoverCamposRodape[1].visible = false;
                this.regConfigCadastroLoverCamposRodape[2].onClick = () =>
                  this.router.navigate(['/home', 'login']);

                this.regConfigCadastroLoverCampos6[0].label =
                  'OBAAAH!\nVOCÊ JÁ É UM CACAU LOVER.';
              }
            },
            (err) => {
              console.error(err);
            }
          );
      } else if (this.etapaAtual == 2)
        this.membro.nome =
          this.regConfigCadastroLoverCampos2[1].value +
          ' ' +
          this.regConfigCadastroLoverCampos2[2].value;
      else if (this.etapaAtual == 3) {
        this.membro.email = this.regConfigCadastroLoverCampos3[1].value;
        // this.membro.telefone = 55;
        this.membro.telefone += this.regConfigCadastroLoverCampos3[2].value;
      } else if (this.etapaAtual == 4) {
        var dado = (<HTMLInputElement>document.getElementById('dataNascimento'))
          .value;
        var dadoSplit = dado.split('/');
        var data = `${dadoSplit[2]}-${dadoSplit[1]}-${dadoSplit[0]}`;

        var date = new Date(data);

        this.membro.dataNascimento = date;
      } else if (this.etapaAtual == 5) {
        this.membro.senha = this.regConfigCadastroLoverCampos5[2].value;
        this.membro.senhaConfirmacao =
          this.regConfigCadastroLoverCampos5[4].value;

        if (this.membro.senha != this.membro.senhaConfirmacao) {
          formularioFalhaRegraNegocio = true;
        } else {
          if (!subtrair) {
            this.membro.genero = 'N';
            this.membro.queroSerLover = true;
            this.membro.origem = 1;
            this.membro.ativo = true;
            this.membro.tipoStatus = 1;

            this.exibirLoaderFullscreen = true;
            this.fidelidadeService.cadastrarMembro(this.membro).subscribe(
              (sucesso) => {
                this.processarSucessoCadastrarMembro(sucesso);
              },
              (error) => {
                this.processarFalhaCadastrarMembro(error);
              }
            );
          }
        }
      }
    }

    if (!formularioFalhaRegraNegocio && formularioValido) {
      if (step == 0) {
        if (this.regConfigCadastroLoverCamposRodape[0].value != 5)
          this.regConfigCadastroLoverCamposRodape[0].value += 1;
      } else {
        if (subtrair)
          this.regConfigCadastroLoverCamposRodape[0].value =
            this.regConfigCadastroLoverCamposRodape[0].value - 1;
        else this.regConfigCadastroLoverCamposRodape[0].value = step;
      }

      this.etapaAtual = this.regConfigCadastroLoverCamposRodape[0].value;

      if (this.etapaAtual > 1)
        this.regConfigCadastroLoverCamposRodape[1].visible = true;
      else this.regConfigCadastroLoverCamposRodape[1].visible = false;

      if (this.etapaAtual == 5)
        this.regConfigCadastroLoverCamposRodape[2].label = 'Finalizar Cadastro';
      else {
        if (this.regConfigCadastroLoverCamposRodape[0].value != 6) {
          this.regConfigCadastroLoverCamposRodape[2].label =
            'Continuar Cadastro';
        }
      }
    } else {
      if (!formularioValido) {
        Swal.fire({
          title: 'Atenção!',
          text: 'Verifique se os campos foram preenchidos corretamente!',
          icon: 'error',
          confirmButtonColor: '#2d1708',
          confirmButtonText: 'Ok',
        }).then(function () {});
      } else if (!this.membro.aceiteTermo && this.etapaAtual == 1) {
        Swal.fire({
          title: 'Atenção!',
          text: 'Não é possível continuar sem aceitar os termos e regulamento do programa!',
          icon: 'error',
          confirmButtonColor: '#2d1708',
          confirmButtonText: 'Ok',
        }).then(function () {});
      } else if (
        this.membro.senha != this.membro.senhaConfirmacao &&
        this.etapaAtual == 5
      ) {
        Swal.fire({
          title: 'Atenção!',
          text: 'A senha está divergente!! Favor verificar!!',
          icon: 'error',
          confirmButtonColor: '#2d1708',
          confirmButtonText: 'Ok',
        }).then(function () {});
      }
    }
  }

  carregarChatCadastro() {
    var self = this;

    this.regConfigCadastroCacauLover = [
      {
        type: 'input',
        inputType: 'text',
        inputmode: 'numeric',
        label: 'Digite seu CPF aqui',
        mask: '000.000.000-00',
        name: 'chat',
        value: '',
        mainIcon: 'fa-paper-plane',
        style(): object {
          return {
            width: '90%',
            height: '40px',
            'font-size': '12px',
            'padding-left': '10px',
            'margin-left': 'calc(7% - 15px)',
            'font-weight': 'bold',
            'font-family': 'Sagona',
            'border-radius': '1rem 0 1rem 1rem',
            'text-align': 'left',
            'background-color': '#E8DFCA !important',
            background: '#E8DFCA !important',
            border: '0',
            outline: 'none',
            'margin-bottom': '-35px',
          };
        },
        styleIcon(): object {
          return {
            'font-size': '20px',
            position: 'fixed',
            right: '4rem',
            'margin-top': '6px',
            color: '#461F1A',
          };
        },
        styleDivPrincipal(): object {
          return {
            'width:': '100%',
            display: 'block',
            margin: '10px 0px',
          };
        },
        onClickIcon() {
          self.prosseguirChat();
        },
      },
    ];

    this.regConfigCadastroCacauLoverTermos = [
      {
        type: 'checkbox',
        label:
          'Li e aceito os termos javascript:abrirFecharPopupTermos(this,true) e condições javascript:abrirFecharPopupRegulamento(this,true) do programa Cacau Lovers',
        name: 'aceitaTermosChat',
        value: false,
        style(): object {
          return {
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '400',
            'font-size': '12px',
            width: '80%',
            display: 'block',
            margin: 'auto',
            'line-height': '11px',
            'text-align': 'left',
          };
        },
      },
      // {
      //   type: 'checkbox',
      //   label:
      //     'Eu aceito receber mensagens \n promocionais e transacionais da Cacau Show por SMS, E-mail e WhatsApp.',
      //   name: 'aceitaComunicacaoChat',
      //   value: false,
      //   style(): object {
      //     return {
      //       'font-family': 'Sagona',
      //       'font-style': 'normal',
      //       'font-weight': '400',
      //       'font-size': '12px',
      //       width: '80%',
      //       display: 'block',
      //       margin: 'auto',
      //       'line-height': '11px',
      //       'text-align': 'left',
      //     };
      //   },
      // },
    ];

    this.regConfigCadastroCacauLoverFinalizar = [
      {
        type: 'button',
        label: 'Finalizar seu cadastro.',
        style(): object {
          return {
            width: '75%',
            'background-color': 'rgb(70, 31, 26)',
            color: 'rgb(244, 178, 65)',
            display: 'block',
            'margin-left': 'auto',
            'margin-right': '10px',
            'border-radius': '1rem 0 1rem 1rem',
          };
        },
        onClick: () => {
          self.prosseguirChat();
        },
      },
    ];

    this.regConfigCadastroCacauLoverFooter = [
      {
        type: 'slider',
        name: 'sliderCadastroLover',
        visible: true,
        value: this.indexChat,
        maxSize: 6,
        disabled: true,
        style(): object {
          return {
            width: '85%',
            display: 'block',
            margin: 'auto',
          };
        },
      },
    ];

    this.chatMensagens = [];
    this.regConfigCadastroCacauLover[0].value = '';
    this.indexChatBot = 0;
    this.indexChat = 1;
    this.regConfigCadastroCacauLoverFooter[0].value = this.indexChat;

    this.exibePopupChatLover = true;
    this.exibirMensagemChat(2);
  }

  prosseguirChat() {
    if (this.indexChat == 7) return;

    if (this.indexChat != 6) {
      var chat = this.regConfigCadastroCacauLover[0];
      var dado = chat.value;

      var chatMensagem = (<HTMLInputElement>document.getElementById('chat'))
        .value;
      if (!chatMensagem) {
        // this.chatMensagens.push(this.chatMensagensBotErro[10]);
        this.irParaOFimDoChat();
        return;
      }
    }

    if (this.indexChat == 6) {
      chatMensagem = '';
      // for (var i = 0; i < dado.length; i++) {
      //     chatMensagem += '*';
      // }
    }
    var mensagem: Mensagem = {
      mensagem: chatMensagem,
      remetente: 1,
    };

    if (this.indexChat != 6) this.chatMensagens.push(mensagem);

    switch (this.indexChat) {
      case 1:
        if (!this.validacao.validarCPF(dado)) {
          this.chatMensagens.push(this.chatMensagensBotErro[0]);
          this.irParaOFimDoChat();
          chat.value = '';
          return;
        }

        this.fidelidadeService.verificarSeJaEstaCadastrado(dado).subscribe(
          (res) => {
            if (res.message === 'CacauLover - Cliente cadastrado na base!') {
              this.chatMensagens.push(this.chatMensagensBotErro[11]);
              this.irParaOFimDoChat();

              chat.value = '';

              this.regConfigCadastroCacauLover = [];
              // this.regConfigCadastroCacauLoverFooter = [];

              this.indexChat = 7;
              this.regConfigCadastroCacauLoverFooter[0].value = this.indexChat;

              this.regConfigCadastroCacauLoverFinalizar[0].label =
                'Faça seu login e aproveite';
              this.regConfigCadastroCacauLoverFinalizar[0].onClick = () =>
                this.router.navigate(['/home', 'login']);
            } else {
              this.cacauLoverCadastro.cpf = dado;

              chat.label = 'Digite seu nome completo';
              chat.mask = null;

              this.exibirMensagemChat(2);
            }
          },
          (err) => {
            console.error(err);

            this.cacauLoverCadastro.cpf = dado;

            chat.label = 'Digite seu nome completo';
            chat.mask = null;

            this.exibirMensagemChat(2);
          }
        );
        break;
      case 2:
        var regexNome = new RegExp('^[a-zA-ZÀ-ú][a-zA-ZÀ-ú\\s]+$');

        if (dado.length < 5) {
          this.chatMensagens.push(this.chatMensagensBotErro[1]);
          this.irParaOFimDoChat();
          chat.value = '';
          return;
        }
        if (!regexNome.test(dado)) {
          this.chatMensagens.push(this.chatMensagensBotErro[6]);
          this.irParaOFimDoChat();
          chat.value = '';
          return;
        }

        this.cacauLoverCadastro.nome = dado;
        var nome = this.cacauLoverCadastro.nome.split(' ')[0];

        this.chatMensagensBot[4].mensagem =
          this.chatMensagensBot[4].mensagem.replace('{NOME}', nome);
        this.chatMensagensBot[9].mensagem =
          this.chatMensagensBot[9].mensagem.replace('{NOME}', nome);

        chat.label = 'Digite seu e-mail';

        this.exibirMensagemChat(2);
        break;
      case 3:
        dado = dado.toLowerCase();
        var regexEmail = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$');

        if (!regexEmail.test(dado)) {
          this.chatMensagens.push(this.chatMensagensBotErro[9]);
          this.irParaOFimDoChat();
          chat.value = '';
          return;
        }

        this.cacauLoverCadastro.email = dado;

        chat.mask = '(00) 00000-0000';
        chat.label = 'Digite seu celular';

        this.exibirMensagemChat(1);
        break;
      case 4:
        dado = '55' + dado;
        if (dado.length < 12) {
          this.chatMensagens.push(this.chatMensagensBotErro[2]);
          this.irParaOFimDoChat();
          chat.value = '';
          return;
        }

        this.cacauLoverCadastro.telefone = dado;

        chat.mask = '00/00/0000';
        chat.label = 'Digite sua data de nascimento';
        chat.inputType = 'text';
        this.exibirMensagemChat(1);
        break;
      case 5:
        dado = (<HTMLInputElement>document.getElementById('chat')).value;
        var dadoSplit = dado.split('/');
        var data = `${dadoSplit[2]}-${dadoSplit[1]}-${dadoSplit[0]}`;

        var hj = new Date();
        var date = new Date(data);

        if (
          hj.getTime() < date.getTime() ||
          date.getFullYear() < hj.getFullYear() - 120
        ) {
          this.chatMensagens.push(this.chatMensagensBotErro[3]);
          this.irParaOFimDoChat();
          chat.value = '';
          return;
        }

        this.cacauLoverCadastro.dataNascimento = date;

        this.regConfigCadastroCacauLover = [];

        // this.regConfigCadastroCacauLover.push(
        //     {
        //         type: 'image',
        //         src: 'assets/images/icons/olho_aberto.png',
        //         styleDivPrincipal(): object {
        //             return {
        //                 position: 'relative',
        //                 display: 'contents',
        //             };
        //         },
        //         style(): object {
        //             return {
        //                 'width': '30px',
        //                 'height': '30px',
        //                 'position': 'absolute',
        //                 'background': 'rgba(244, 178, 65, 0.5)',
        //                 'border-radius': '500px',
        //                 'margin-top': '-44px',
        //                 'right': '25px',
        //                 'z-index': '5'
        //             };
        //         },
        //         onClick: () => {
        //             if (this.regConfigCadastroCacauLover[0].inputType === "password") {
        //                 this.regConfigCadastroCacauLover[0].inputType = "text";
        //                 this.regConfigCadastroCacauLover[1].src = "assets/images/icons/olho_fechado.png";
        //             } else {
        //                 this.regConfigCadastroCacauLover[0].inputType = "password";
        //                 this.regConfigCadastroCacauLover[1].src = "assets/images/icons/olho_aberto.png";
        //             }
        //         },
        //     },
        // );

        this.exibirMensagemChat(1);
        break;
      case 6:
        //var regexSenha = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&].{7,}$');

        var termos = (<HTMLInputElement>(
          document.getElementById('aceitaTermosChat-input')
        )).checked;
        // var comunicacao = (<HTMLInputElement>(
        //   document.getElementById('aceitaComunicacaoChat-input')
        // )).checked;

        if (!termos) {
          this.chatMensagens.push(this.chatMensagensBotErro[5]);
          this.irParaOFimDoChat();
          chat.value = '';
          return;
        }

        // if (dado.length < 6) {
        //     this.chatMensagens.push(this.chatMensagensBotErro[4]);
        //     this.irParaOFimDoChat();
        //     chat.value = "";
        //     return;
        // }

        //if (!regexSenha.test(dado)) {
        //this.chatMensagens.push(this.chatMensagensBotErro[7]);
        //this.irParaOFimDoChat();
        //chat.value = "";
        //return;
        //}

        //this.cacauLoverCadastro.senha = dado;
        //this.cacauLoverCadastro.senhaConfirmacao = dado;

        this.cacauLoverCadastro.aceiteTermo = termos;
        this.cacauLoverCadastro.enviaComunicacao = true;

        this.cacauLoverCadastro.genero = 'N';
        this.cacauLoverCadastro.queroSerLover = true;
        this.cacauLoverCadastro.origem = 1;
        this.cacauLoverCadastro.ativo = true;
        this.cacauLoverCadastro.tipoStatus = 1;

        this.regConfigCadastroCacauLover = [];

        this.exibirLoaderFullscreen = true;

        this.fidelidadeService
          .cadastrarMembro(this.cacauLoverCadastro)
          .subscribe(
            (sucesso) => {
              this.processarSucessoCadastroMembroChat(sucesso);
            },
            (error) => {
              this.processarFalhaCadastroMembroChat(error);
            }
          );
    }

    if (chat != undefined) chat.value = '';

    this.indexChat += 1;
    this.regConfigCadastroCacauLoverFooter[0].value = this.indexChat;

    if (this.indexChat == 1 || this.indexChat == 4) chat.inputmode = 'numeric';
    else chat.inputmode = 'text';
  }

  exibirMensagemChat(n: number) {
    for (let i = 0; i < n; i++) {
      this.chatMensagens.push(this.chatMensagensBot[this.indexChatBot++]);
    }
    this.irParaOFimDoChat();
  }

  irParaOFimDoChat() {
    setTimeout(() => {
      this.chatScroll.nativeElement.scrollTop =
        this.chatScroll.nativeElement.scrollHeight;
    }, 120);
  }

  formularioValido(stepAtual: number): boolean {
    const form: HTMLFormElement = document.querySelector(
      '#dinamicForm' + stepAtual + ' form'
    );

    if (form.classList.contains('ng-invalid')) return false;

    return true;
  }

  processarSucessoCadastroMembroChat(response: any) {
    this.exibirLoaderFullscreen = false;

    this.regConfigCadastroCacauLoverFinalizar[0].label =
      'Crie sua senha e aproveite.';

    this.regConfigCadastroCacauLoverFinalizar[0].onClick = () => {
      this.router.navigate(['/home/login']);
      // this.AuthService.loginComSenha(this.cacauLoverCadastro.cpf, this.cacauLoverCadastro.senha).subscribe(
      //     sucesso => { this.processarSucessoLogin(sucesso) },
      //     falha => { this.processarFalhaLogin(falha) }
    };

    this.exibirMensagemChat(1);
  }

  processarSucessoLogin(response: any) {
    this.exibirLoaderFullscreen = false;

    this.AuthService.LocalStorage.salvarDadosLocaisUsuario(response);

    this.fidelidadeService.obterMembro().subscribe(
      sucesso => {
        this.AuthService.LocalStorage.salvarMembro(sucesso);
        this.router.navigate(['/index']);
      });
  }
  processarFalhaLogin(fail: any) {
    this.exibirLoaderFullscreen = false;
    alert('usuário e senha não coincidem!');
  }

  processarFalhaCadastroMembroChat(error: any) {
    this.exibirLoaderFullscreen = false;

    console.error(error);

    this.regConfigCadastroCacauLoverFinalizar = [];

    if (error == 'Já existe um cadastro com o CPF informado')
      this.chatMensagens.push(this.chatMensagensBotErro[11]);
    else if (
      error == 'Apenas pessoas maiores de 18 anos podem participar do programa!'
    )
      this.chatMensagens.push(this.chatMensagensBotErro[12]);
    else this.chatMensagens.push(this.chatMensagensBotErro[8]);

    this.irParaOFimDoChat();
  }

  processarSucessoCadastrarMembro(response: any) {
    this.exibirLoaderFullscreen = false;

    this.regConfigCadastroLoverCamposRodape[2].label =
      'Faça o login e aproveite.';
    this.regConfigCadastroLoverCamposRodape[0].visible = false;
    this.regConfigCadastroLoverCamposRodape[1].visible = false;

    this.regConfigCadastroLoverCamposRodape[2].onClick = () => {
      this.exibirLoaderFullscreen = true;

      this.AuthService.loginComSenha(
        this.membro.cpf,
        this.membro.senha
      ).subscribe(
        (sucesso) => {
          this.processarSucessoLogin(sucesso);
        },
        (falha) => {
          this.processarFalhaLogin(falha);
        }
      );
    };

    this.etapaAtual = this.regConfigCadastroLoverCamposRodape[0].value += 1;
    // this.regConfigCadastroLoverCamposRodape[2].onClick = () => this.router.navigate(["/"]);
  }

  processarFalhaCadastrarMembro(response: any) {
    this.exibirLoaderFullscreen = false;

    Swal.fire({
      title: 'Atenção!',
      text: response,
      icon: 'error',
      confirmButtonColor: '#2d1708',
      confirmButtonText: 'Ok',
    }).then(function () {});
  }

  processarSucessoTermos(response: any) {
    var linhas = response.valor.split('\n');

    for (let index = 0; index < linhas.length; index++) {
      if (linhas[index] == '\r') continue;

      if (index == 0) {
        this.regConfigPopupTermos.push({
          type: 'label',
          label: '\n' + linhas[index],
          style(): object {
            return { 'font-size': '1.5em', 'font-weight': 'bolder' };
          },
        });
      } else {
        this.regConfigPopupTermos.push({
          type: 'label',
          label: '\n' + linhas[index],
          style(): object {
            return {};
          },
        });
      }
    }
  }

  processarFalhaTermos(fail: any) {
    console.error('teste: ', fail);
  }

  processarSucessoRegulamento(response: any) {
    var linhas = response.valor.split('\n');

    for (let index = 0; index < linhas.length; index++) {
      if (linhas[index] == '\r') continue;

      if (index == 0) {
        this.regConfigPopupRegulamento.push({
          type: 'label',
          label: '\n' + linhas[index],
          style(): object {
            return { 'font-size': '1.5em', 'font-weight': 'bolder' };
          },
        });
      } else {
        this.regConfigPopupRegulamento.push({
          type: 'label',
          label: '\n' + linhas[index],
          style(): object {
            return {};
          },
        });
      }
    }
  }

  processarFalhaRegulamento(fail: any) {
    console.error(fail);
  }
}
